import moment from 'moment';

const COOKIES_ACCEPTED_KEY = 'TL_COOKIES_ACCEPTED';

function Ctrl($rootScope, $scope, $timeout, $cookies) {
  const cookieShowValue = $cookies.get(COOKIES_ACCEPTED_KEY);

  $timeout(() => {
    $scope.visible = !cookieShowValue;
  }, 1000);

  $rootScope.$on('$stateChangeStart', () => {
    $scope.acceptCookies();
  });

  $scope.acceptCookies = function($event) {
    if ($event) $event.preventDefault();

    $cookies.put(COOKIES_ACCEPTED_KEY, true, {
      expires: moment().add(1, 'year').toDate()
    });

    $scope.visible = false;
  };
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  '$timeout',
  '$cookies'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/cookieBanner/controller.js